import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Dropzone from 'react-dropzone';
import objectHash from 'object-hash';
import { bytesToSize, removeDuplicates } from '../../utils/helpers';
import MessageModal from '../Modals/MessageModal';

export default class FileUploader extends React.Component {
  constructor() {
    super();

    this.dropzoneRef = React.createRef();

    this.MAXSIZE = 20 * 1024 * 1024; // 20 mb
    this.MAXFILES = 5;

    this.state = {
      files: [],
      showModalMessage: false,
      modalMessage: '',
      modalTitle: ''
    };
  }

  showAlert(message, title = '') {
    this.setState({
      modalTitle: title,
      modalMessage: message,
      showModalMessage: true,
    });
  }

  onDropAccepted(files) {
    let newFiles = [
      ...this.state.files,
      ...files.map(file => ({
        file,
        name: file.name,
        size: file.size,
        hash: objectHash.sha1(file.name + file.size + file.lastModified),
        preview: URL.createObjectURL(file),
      })),
    ];

    newFiles = removeDuplicates(newFiles, 'hash');

    if (newFiles.length > this.MAXFILES) {
      this.showAlert(`Максимальное количество файлов для загрузки - ${this.MAXFILES}`);
      newFiles = newFiles.slice(0, this.MAXFILES);
    }

    this.setState({
      files: newFiles,
    });

    const attachments = newFiles.map(item => item.file);
    this.props.setAttachments(attachments);
  }

  onDropRejected(files) {
    if (files.some(file => file.size > this.MAXSIZE)) {
      this.showAlert('Максимальный размер загружаемого файла - 20 МБ');
    } else {
      this.showAlert('Ваши файлы не удовлетворяют требованиям');
    }
  }

  uploadFiles = () => {
    this.setState(
      {
        // accept: '.pdf, .doc, .docx, .xls',
        accept: '',
      },
      this.dropzoneRef.current.open,
    );
  };

  uploadImages = () => {
    this.setState(
      {
        accept: 'image/jpeg, image/png',
      },
      this.dropzoneRef.current.open,
    );
  };

  uploadVideos = () => {
    this.setState(
      {
        accept: 'video/ogg, video/mp4',
      },
      this.dropzoneRef.current.open,
    );
  };

  dismissFile(fileToDismiss) {
    const updatedFiles = this.state.files.filter(file => file.hash !== fileToDismiss.hash);
    this.setState(
      {
        files: updatedFiles,
      },
      () => {
        const attachments = this.state.files.map(item => item.file);
        this.props.setAttachments(attachments);
      },
    );
  }

  componentWillUnmount() {
    const { files } = this.state;
    for (let i = files.length; i >= 0; i--) {
      const file = files[0];
      if (file) {
        URL.revokeObjectURL(file.preview);
      }
    }
  }

  render() {
    const {
      files, accept, showModalMessage, modalMessage,
    } = this.state;

    // const thumbs = files.map(file => (
    //   <div style={thumb}>
    //     <div style={thumbInner}>
    //       {file.preview ? <img src={file.preview} style={img} /> : 'filename'}
    //     </div>
    //   </div>
    // ));

    const fileList = (
      <ul className="attachments__file-list">
        {files.map(file => (
          <li className="attachments__file">
            <span className="attachments__file-info">
              {`${file.name}  -  ${bytesToSize(+file.size)}`}
              <button className="attachments__file-delete" onClick={() => this.dismissFile(file)} />
            </span>
          </li>
        ))}
      </ul>
    );

    return (
      <section className="input-group__attachments-section" style={{ display: files.length ? 'block' : 'none' }}>
        <div className="dropzone" style={{ display: 'none' }}>
          <Dropzone
            // accept="image/*"
            maxSize={this.MAXSIZE}
            accept={accept}
            onDropAccepted={this.onDropAccepted.bind(this)}
            onDropRejected={this.onDropRejected.bind(this)}
            ref={this.dropzoneRef}
          >
            {}
          </Dropzone>
        </div>
        {/* <aside style={thumbsContainer}>{thumbs}</aside> */}
        <aside>{fileList}</aside>
        <MessageModal
          visible={showModalMessage}
          message={modalMessage}
          hide={() => {
            this.setState({ showModalMessage: false });
          }}
        />
      </section>
    );
  }
}
